import { IPicture } from '../../../pictures/types';
import { IApiPicture } from './picture.types';

export const pictureSerializer = (apiPicture: IApiPicture): IPicture => {
  const { attributes } = apiPicture;

  return {
    id: apiPicture.id,
    attributes: {
      aboid: attributes.aboid,
      isMainPicture: attributes.isMainPicture,
      isOnModeration: attributes.isOnModeration,
      formats: { ...attributes.formats },
    },
  };
};
